<template>
	<div :class="[{ 'is-survey': isSurvey }, {'is-not-survey': !isSurvey}]">
		<div class="video-response">
			<div class="response" v-for="(r, i) in response" :key="i">
				<div class="date" v-if="response.length > 1">
					{{ formatDate(questionnaire[i].completed) }}
				</div>
				<div class="answer-wrapper">
					<VideoConsentPartial
						:response="r" 
						:question="question" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import QuestionResponse from '.'
import { mapGetters } from 'vuex'
import VideoConsentPartial from './partialResponse/VideoConsentPartial'

export default {
	name: 'video',

	extends: QuestionResponse,

	data() {
		return {
		}
	},

	computed: {
		...mapGetters(['getUserType']),
		...mapGetters('user', ['getUser']),
		...mapGetters('auth', ['getUserId']),
		...mapGetters('provider', [ 'allPatientsChosen', 'getProviderNameById']),
	},

	components: {
		VideoConsentPartial
	}
}
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>
